import API from '../helpers/interceptor';

export const getTenants = () =>
    API.post('/tenant/list', {});

export const saveTenant = (data) =>
    API.post('/tenant/save', data);

export const getTenantHistory = (tenantId) =>
    API.post('/tenant/history', { tenantId });

export const checkUserTenants = () =>
    API.post('/tenant/checkuser');
